
/**
 * Questão que o usuário formula e que pode ser enviada
 * para o serviço do Serprobots para obter uma Mensagem de resposta.
 * 
 * Separamos a Question da Message, pois a primeira é mais simples, enquanto
 * a segunda carrega muitos outros dados que são desnecessários na Question.
 */
export class Question {
    conversationId: string;
    text: string;
    parameters = {};

    constructor(conversationId: string, text: string, parameters = {}) {
        this.conversationId = conversationId;
        this.text = text;
        this.parameters = parameters;
    }

}